import jwt from "jsonwebtoken";

export const verifyToken = function (token) {
  return new Promise((resolve, reject) => {
    // ignoreExpiration: the server is the only authority on token validity; a real
    // rejection arrives as a "failed-token" / 401 response, which still logs out.
    jwt.verify(token, "RoofAPI", { ignoreExpiration: true }, async (err, user) => {
      if (err) {
        reject(err);
      } else {
        resolve(user);
      }
    });
  });
};
